/***************************
 * 处理Object相关的一些常规方法
 ***************************/

/**
 * 对象深度对比判断相等
 * @param a Object
 * @param b Object
 * @return Boolean
 * Example:  equals({ a: [2, { e: 3 }], b: [4], c: 'foo' }, { a: [2, { e: 3 }], b: [4], c: 'foo' }) -> true
 */
export const equals = (a, b) => {
  if (a === b) return true
  if (a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime()
  }
  if (!a || !b || (typeof a !== 'object' && typeof b !== 'object')) {
    return a === b
  }
  if (a === null || a === undefined || b === null || b === undefined) {
    return false
  }
  if (a.prototype !== b.prototype) return false
  let keys = Object.keys(a)
  if (keys.length !== Object.keys(b).length) return false
  return keys.every(k => equals(a[k], b[k]))
}

/**
 * 对象深拷贝，改变引用指向
 * @param obj 需要拷贝的对象
 * @return
 */
export const deepClone = obj => {
  if (!obj && typeof obj !== 'object') {
    throw new Error('error arguments')
  }
  const targetObj = Array.isArray(obj) ? [] : {}
  for (let key in obj) {
    // 只对对象自有属性进行拷贝
    if (obj.hasOwnProperty(key)) {
      if (obj[key] && typeof obj[key] === 'object') {
        targetObj[key] = deepClone(obj[key])
      } else {
        targetObj[key] = obj[key]
      }
    }
  }
  return targetObj
}

/**
 * 彻底冻结对象
 * @param obj 需要冻结的对象
 * @return
 */
export const freezeObj = obj => {
  Object.freeze(obj)
  Object.keys(obj).forEach(key => {
    typeof obj[key] === 'object' && freezeObj(obj[key])
  })
}
// 过滤掉重复的key
export const filterDupKey = (arr1, arr2) => {
  const array = [...arr1, ...arr2]
  for (let i = 0; i < array.length; i++) {
    // eslint-disable-next-line
    for (let j = i + 1; j < array.length; ) {
      // 通过key属性进行匹配；
      if (array[i].key == array[j].key) {
        // 去除重复的对象
        array.splice(j, 1)
      } else {
        j++
      }
    }
  }
  return array
}

export class TranslateKey {
  constructor(options) {
    this.options = options
  }
  handle(data, func) {
    if (!Array.isArray(data)) {
      data = [data]
    }
    const opts = Object.entries(this.options)
    return data.map(item => {
      const temp = { ...item }
      const arr = opts.map(([sourceKey, targetKey]) => {
        const [source, target] = func(sourceKey, targetKey)
        const obj = { [target]: temp[source] }
        delete temp[source]
        return obj
      })
      Object.assign(temp, ...arr)
      return temp
    })
  }
  // key => value
  translate(data) {
    return this.handle(data, (...args) => {
      return args
    })
  }
  untranslate(data) {
    return this.handle(data, (...args) => {
      return args.reverse()
    })
  }
}

/**
 * 对象中获取指定值
 * @param {Object} obj 对象
 * @param {String} str 字符串
 * @param {String} mark 分隔符
 */
export const getPorperty = (obj, str, mark = '.') => {
  if (!str) return null
  const arr = str.split(mark)
  return arr.reduce((current, value) => {
    if (current) {
      return current[value]
    }
  }, obj)
}
